var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-image",style:({ transform: _vm.moveParsed })},[_c('div',{staticClass:"result-image__image",class:{
      'is-active': _vm.isActive,
      '-zoom-in': _vm.zoomIn,
      '-zoom-in-2': _vm.zoomIn2
    },style:({ backgroundImage: ("url(" + _vm.image + ")") })})])}
var staticRenderFns = []

export { render, staticRenderFns }